import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Modal from 'react-modal';
import { Player } from 'video-react';
import LazyBg from '../../../UI/LazyImage/LazyBg';
import './Gallery.css';

class Gallery extends React.Component {
    constructor(props) {
        super(props);
        this.player = React.createRef();
        this.handleStateChange = this.handleStateChange.bind(this);
        this.state = {
            modalIsOpen: false,
            slideIndex: 0,
            updateCount: 0,
        };
    }

    toggleModal = i => {
        if (i === null) return;
        this.setState(prevState => ({
            modalIsOpen: !prevState.modalIsOpen,
            slideIndex: i,
        }));
    };

    handleStateChange(state, prevState) {
        // copy player state to this component's state
        this.setState({
            player: state,
        });
    }

    componentDidMount(prevProps, prevState) {
        // subscribe state change
        this.handleStateChange.bind(this);
    }

    pause() {
        this.player.current.actions.pause();
    }

    render() {
        const { web_photos } = this.props.property;
        const { isMobile } = this.props.screen;

        const isVideoAsset = () => {
            let isVideo = web_photos.find(item => item.includes('mov'))
                ? true
                : web_photos.find(item => item.includes('mp4'))
                    ? true
                    : web_photos.find(item => item.includes('webm'))
                        ? true
                        : false;

            return isVideo;
        };

        const getGallerySliderTemplate = () => {
            return web_photos.map((asset, i, webPhotosArray) => {
                let templateString;

                // if the property has a video for the first asset then load the react video component
                if (isVideoAsset() && i === 0) {
                    templateString = (
                        <div className="key" key={i}>
                            <Player
                                ref={this.player}
                                autoPlay={false}
                                preload="none"
                                playsInline={false}
                                aspectRatio="16:9"
                                poster={`${process.env.RAZZLE_ASSET_URL}` + webPhotosArray[1]}
                            >
                                <source src={`${process.env.RAZZLE_ASSET_URL}` + webPhotosArray[0]} type="video/mp4" />
                            </Player>
                        </div>
                    );
                } else if (isVideoAsset() ? i < webPhotosArray.length - 1 : i <= webPhotosArray.length - 1) {
                    templateString = (
                        <div className="key" key={i}>
                            <LazyBg
                                className="slide-image"
                                src={
                                    isVideoAsset()
                                        ? process.env.RAZZLE_ASSET_URL + webPhotosArray[i + 1]
                                        : process.env.RAZZLE_ASSET_URL + webPhotosArray[i]
                                }
                            ></LazyBg>
                            {/* <div
                                className="slide-image"
                                style={{
                                    backgroundImage: `url(${
                                        isVideoAsset()
                                            ? process.env.RAZZLE_ASSET_URL + webPhotosArray[i + 1]
                                            : process.env.RAZZLE_ASSET_URL + webPhotosArray[i]
                                    })`,
                                }}
                            /> */}
                        </div>
                    );
                }

                return templateString;
            });
        };

        const getGalleryGridTemplate = () => {
            return web_photos.map((asset, i, webPhotosArray) => {
                let templateString;

                // only return the first 6 assets
                if (i < 6) {
                    const backgroundImage = isVideoAsset()
                        ? process.env.RAZZLE_ASSET_URL + webPhotosArray[i + 1]
                        : process.env.RAZZLE_ASSET_URL + webPhotosArray[i];
                    const classNameField = isVideoAsset() && i === 0 ? 'grid-image is-video' : 'grid-image';

                    templateString = (
                        <div
                            className={`column ${
                                i === 0
                                    ? 'is-6 ratio-box-short-rectangle'
                                    : i === 1
                                        ? 'is-3 ratio-box-tall-rectangle'
                                        : i === 2
                                            ? 'is-3 ratio-box-tall-rectangle'
                                            : i > 2
                                                ? 'is-4'
                                                : ''
                            }`}
                            key={i}
                        >
                            {isVideoAsset() && i === 0 ? (
                                <div
                                    role="link"
                                    tabIndex="-1"
                                    onClick={() => this.toggleModal(i)}
                                    onKeyUp={() => this.toggleModal(null)}
                                    className={classNameField}
                                    style={{ backgroundImage: `url(${backgroundImage})` }}
                                >
                                    <div className="play-video-button">Play</div>
                                </div>
                            ) : (
                                <div
                                    role="link"
                                    tabIndex="-1"
                                    onClick={() => this.toggleModal(i)}
                                    onKeyUp={() => this.toggleModal(null)}
                                >
                                    <LazyBg className={classNameField} src={backgroundImage}></LazyBg>
                                </div>
                            )}
                        </div>
                    );
                }

                return templateString;
            });
        };

        const settings = {
            infinite: false,
            centerMode: false,
            arrows: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: false,
            afterChange: () =>
                this.setState(state => ({ updateCount: state.updateCount + 1 }), isVideoAsset() ? this.pause : null),
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        infinite: false,
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        const modalSettings = {
            infinite: false,
            centerMode: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            afterChange: () =>
                this.setState(state => ({ updateCount: state.updateCount + 1 }), isVideoAsset() ? this.pause : null),
        };

        return web_photos && web_photos.length > 0 ? (
            <section className="section section-gallery">
                <div className="container">
                    <div className="columns">
                        <div className="column is-10-tablet is-offset-1-tablet">
                            <h3 className="big-title border-left-yellow">Gallery</h3>
                        </div>
                    </div>
                    {isMobile ? (
                        <div className="gallery-slider">
                            <Slider {...settings}>{getGallerySliderTemplate()}</Slider>
                        </div>
                    ) : (
                        <div>
                            <div className="gallery-grid">
                                <div className="columns is-multiline">{getGalleryGridTemplate()}</div>
                            </div>
                            <Modal
                                overlayClassName="Overlay section-gallery gallery-overlay modal-fade"
                                className="Modal section-gallery gallery-modal modal-fade"
                                isOpen={this.state.modalIsOpen}
                                onAfterOpen={this.afterOpenModal}
                                onRequestClose={this.toggleModal}
                                shouldCloseOnOverlayClick={true}
                                shouldCloseOnEsc={true}
                            >
                                <div className="slick-wrapper">
                                    <div className="button-wrapper">
                                        <button onClick={this.toggleModal} className="close-button">
                                            <span className="close-text">CLOSE</span>
                                            <span className="close-times">&#x2715;</span>
                                        </button>
                                    </div>

                                    <Slider initialSlide={this.state.slideIndex} {...modalSettings}>
                                        {getGallerySliderTemplate()}
                                    </Slider>
                                </div>
                            </Modal>
                        </div>
                    )}
                </div>
            </section>
        ) : null;
    }
}

Gallery.propTypes = {
    property: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
};

export default Gallery;
